<template>
  <div class="big_box">
    <div class="head_title">
      <div class="first_top">
        <div class="logo">
          <img :src="logo" alt="" />
        </div>
        <div class="title">
          <div @click='goPage(item)' class="sm_title" v-for="(item, index) in titleList" :key="index">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <!-- <h1>{{ msg }}</h1> -->
    <div class="privacy_box">
      <Privacy></Privacy>
    </div>
  </div>
</template>

<script>
import Privacy from '../components/privacy.vue';
export default {
  name: 'HelloWorld',
  components:{ Privacy },
  data(){
    return{
      logo: "https://img.fencerspage.com/upload/oss/club/contest/20240522/1119664da8a77879f.png",
      titleList: [
        { name: "约剑官网", id: 1 },
        { name: "约剑简介", id: 2 },
        { name: "探索多元化业务", id: 3 },
        { name: "案例展示", id: 4 },
        { name: "商务合作", id: 5 },
        { name: "服务与支持", id: 6 },
        { name: "应用与下载", id: 7 },
      ],
    }
  },

  
  methods:{
    goPage(data){
      let url 
      if(data.id==1) url='/'
      else return
      this.$router.push({ path: url})
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .big_box{
    background-color: #efefef;
    padding-bottom:30px;
  }

  .head_title{
    background-color: #000;
    
  .first_top {
    height:60px;
    width:1000px;
    margin:0 auto;
    align-items: center;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      width: 30px; 
      height: 30px; 
    }

    .title {
      display: flex;

      .sm_title {
        cursor: pointer;
        font-size: 0.5em; //17
        font-weight: 700;
        color: #fff;
        // margin-left: 2em; //50
        margin-left: 2.8em; //50
      }
    }
  }
  }

  .privacy_box{
    width: 1000px;
    margin: 30px auto ;
    margin-bottom:0;
  }
</style>
